import { QuestionCircleOutlined } from '@ant-design/icons';
import React from 'react';
import Header from '@/components/Header/Header';
import { getLoggedInUser } from '@/store/account/selector';
import { useAppSelector } from '@/store/hooks/useAppSelector';

const ExploreFeaturesPage: React.FC = () => {
	const baseClass = 'contact-support';
	const loggedInUser = useAppSelector(getLoggedInUser);

	return (
		<div className={`${baseClass} overflow-y-hidden`}>
			<Header
				title="Explore Features"
				description="Explore our features and get started with our platform"
				icon={<QuestionCircleOutlined />}
				debrand={loggedInUser?.resellerClient}
			/>
			<iframe
				src="https://www.myaifrontdesk.com/features?_gl=1*w3ug06*_ga*Njg5MDk0NDA4LjE3Mjk1NDAwMTc.*_ga_HB2EWC05TR*MTczMDE0NDM0Ni4yNC4wLjE3MzAxNDQzNDYuMC4wLjA.*_gcl_au*MTU3Nzk5MzgwNS4xNzI5NTQwMDE3LjExODU0Nzk4MzUuMTcyOTc4MjE5Ny4xNzI5NzgyMTk3"
				className={`${baseClass}__content overflow-y-hidden mt-4`}
			/>
		</div>
	);
};

export default ExploreFeaturesPage;
